<template>
  <el-input :value="value" @input="changeValue" :placeholder="placeholder" :disabled="disabled" :maxlength="maxLength" />
</template>
<script>
export default {
  methods: {
    changeValue(val) {
      const result = this.isAreaCode ? val.replace(/[^\d]/g,'') : parseInt(val.replace(/[^\d]/g,'').replace(/^0{1,}/g,""))
      this.$emit("update:value", isNaN(result) ? null : result)
    }
  },
  props: {
    value: {
      type: Number | String,
      default: 0
    },
    placeholder: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    maxLength: {
      type: Number,
      default: () => 20
    },
    isAreaCode: {
      type: Boolean,
      default: () => false
    },
  }
}
</script>